export default __webpack_public_path__ + "media/c44f640f8f381983bc97df60372761b481bd7f3d06ac0eba1c41bfdd7a4d88a9.svg";